import React from 'react';
import { JobsTable } from '../../jobs/JobsTable';

export function TasksTab() {
    return <JobsTable />;
}

export default TasksTab;


